import { INIT_PUZZLE, INIT_CHAPTER_LIST, CHANGE_QUESTION, SELECTED_OPTION, CHANGE_ACTIVE_MODULE, SET_PUZZLE_PROGRESSID, PUZZLE_COMPLETED_MODAL } from '../Actions/actionTypes';

const INIT_STATE = {
  question: [],
  value: 0,
  progressID: null,
  isProgressCompleted: false,
  isCompleted: false,
  isPreviouslyCompleted: false,
  score: null,
  response: {},
  points: 0,
  completedPuzzleModal: false,
};

const Puzzle = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_PUZZLE:
      return {
        ...state,
        question: action.question,
        isPreviouslyCompleted: action.isPreviouslyCompleted,
        response: action.puzzlelastAttempt,
      };

    case CHANGE_QUESTION:
      return {
        ...state,
        value: action.value,
      };

    case CHANGE_ACTIVE_MODULE:
    case INIT_CHAPTER_LIST:
      return {
        ...state,
        ...INIT_STATE,
      };

    case SET_PUZZLE_PROGRESSID:
      return {
        ...state,
        progressID: action.progressID,
      };

    case PUZZLE_COMPLETED_MODAL:
      return {
        ...state,
        completedPuzzleModal: action.status,
      };

    case SELECTED_OPTION:
      // let points = state.points;
      // if(action.status === true && state.isCompleted !== true && !state.response[action.id] ){
      //     points = points + action.ruleSets["PUZZLE_ATTEMPT"];
      // }

      let response = { ...state.response, [action.id]: { selected: action.selected, status: action.status, questionType: action.questionType } };

      return {
        ...state,
        response,
        isProgressCompleted: action.progress.isProgressCompleted,
        isCompleted: action.progress.isCompleted,
        isPreviouslyCompleted: state.isPreviouslyCompleted || action.progress.isCompleted,
        score: action.progress.score,
        // points
      };

    default:
      return state;
  }
};

export default Puzzle;
